var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "editUserDetailsModalRef",
      attrs: {
        id: "edit-user-details-modal",
        size: "lg",
        title: "Editar detalhes do usuário"
      },
      on: { ok: _vm.handleOk }
    },
    [
      _c(
        "form",
        {
          ref: "form",
          on: {
            submit: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", gap: "2rem", width: "100%" } },
            [
              _c("PhoneInput", {
                model: {
                  value: _vm.userDetailsForm.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.userDetailsForm, "phone", $$v)
                  },
                  expression: "userDetailsForm.phone"
                }
              }),
              _vm._v(" "),
              _c("EmailInput", {
                staticStyle: { width: "100%" },
                model: {
                  value: _vm.userDetailsForm.email,
                  callback: function($$v) {
                    _vm.$set(_vm.userDetailsForm, "email", $$v)
                  },
                  expression: "userDetailsForm.email"
                }
              })
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }